/**
 * Menu item configurations for desktop and mobile
 */

const menuSettings = [
  {
    label: 'Home',
    tooltip: 'Home page',
    link: '/home',
    icon: 'home',
  },
  {
    label: 'Events',
    tooltip: 'Event list',
    link: '/events',
    icon: 'clipboard-list',
  },
  {
    label: 'Units',
    tooltip: 'Active unit list',
    link: '/units',
    icon: 'shield-alt',
  },
  {
    label: 'Map',
    tooltip: 'Map',
    link: '/map',
    icon: 'map-marker-alt',
  },
];

export default menuSettings;
